<template>
    <div class="innerBox" style="background-color: #1F4068; padding-top:18px">
        <div class="row" style="display: flex; justify-content: space-between;">
            <h5 class="text-white" style="margin:auto 0">Work Order</h5>
        </div>
        <div class="divider"></div>

        <div class="align-spacely" style="height:840px"><!-- HEIGHT HERE -->
            <div class="mini-stats row">
                <div class="col-8">
                    <h3 class="custom-text-pink">Total Work Order</h3>
                    <h3 class="text-white pl-3">{{ numberWithCommas(data.Total) }}</h3>
                </div>
                <div class="col-4 icon">
                    <i class="fas fa-globe"></i>
                </div>
            </div>

            <div class="mini-stats row mt-3">
                <div class="col-12">
                    <h3 class="custom-text-pink">Total Complain Work Order</h3>
                    <h3 class="text-white pl-3">{{ numberWithCommas(data.Complaint) }}</h3>
                </div>
            </div>

            <div class="divider"></div>

            <div class="row">
                <div class="col">
                    <h3 class="custom-text-pink">Work Order Ongoing</h3>
                    <div class="pl-2 mt-3">
                        <table class="w-100">
                            <template v-for="step in listOfWOStep">
                                <tr :key="step" v-if="step != 'total' && step != 'Selesai'">
                                    <td class="home-table-content font-weight-bold">{{step}}</td>
                                    <td class="home-table-content text-center">{{
                                        numberWithCommas(isNaN(data[step]) ? 0 :
                                        data[step]) }}
                                    </td>
                                </tr>
                            </template>
                        </table>
                    </div>
                </div>
            </div>

            <div class="divider"></div>

            <div class="mini-stats row">
                <div class="col-8">
                    <h3 class="custom-text-pink">Work Order Selesai</h3>
                    <h3 class="text-white pl-3">{{ numberWithCommas(data.Selesai) }}</h3>
                </div>
                <div class="col-4 icon">
                    <i class="fas fa-broom"></i>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        data () {
            return {
                listOfWOStep: ['Pending', 'Warna', 'Bongkar', 'Las', 'Ketok', 'Dempul', 'Epoxy', 'Amplas Alus', 'Cat Base Coat', 'Cat', 'Pasang', 'Poles', 'Finishing'],
            }
        },
        props : ['data'],
        mounted () {

        },
        methods : {

        }
    }
</script>

<style scoped>
    .innerBox {
        overflow-y: auto;
    }
</style>